export const LICENCE_ROLE_OPTIONS = [
  { value: "TR", label: "Technical Representative (TR)" },
  { value: "RO", label: "Responsible Officer (RO)" },
];

export const MPFA_ROLE_OPTIONS = [
  { value: "SI", label: "Subsidiary Intermediary (SI)" },
  { value: "RO", label: "Responsible Officer (RO)" },
];

export const SFC_LICENCE_ROLE_OPTIONS = [
  { value: "LR", label: "Licensed Representative (LR)" },
  { value: "RO", label: "Responsible Officer (RO)" },
];

export const DEFAULT_LICENCE_ROLE = "TR";
export const DEFAULT_MPFA_ROLE = "SI";
export const DEFAULT_SFC_LICENCE_ROLE = "LR";

export const getLicenceRoleLabel = (role, t) => {
  if (role === "RO") {
    return t ? t("Responsible Officer (RO)") : "Responsible Officer (RO)";
  }
  return t
    ? t("Technical Representative (TR)")
    : "Technical Representative (TR)";
};

export const getMpfaRoleLabel = (role, t) => {
  if (role === "RO") {
    return t ? t("Responsible Officer (RO)") : "Responsible Officer (RO)";
  }
  return t
    ? t("Subsidiary Intermediary (SI)")
    : "Subsidiary Intermediary (SI)";
};

export const getSfcRoleLabel = (role, t) => {
  if (role === "RO") {
    return t ? t("Responsible Officer (RO)") : "Responsible Officer (RO)";
  }
  return t
    ? t("Licensed Representative (LR)")
    : "Licensed Representative (LR)";
};

export const normalizeMpfaRole = (role) => {
  if (!role || role === "TR") return DEFAULT_MPFA_ROLE;
  return role;
};
